import { useState } from 'react'
import { Trash2 } from 'lucide-react'
import { Button } from '@teach/ui'
import { DeleteInstructionDialog } from '@/features/instructions/components/DeleteInstructionDialog'
import { useMessages } from '@/i18n'
import { messages } from '../messages'

interface Props {
  onDelete: () => void
  instructionTitle: string
}

export const DeleteSection = ({ onDelete, instructionTitle }: Props) => {
  const [open, setOpen] = useState(false)
  const m = useMessages(messages)

  return (
    <>
      <Button variant="destructive" onClick={() => setOpen(true)} className="gap-2">
        <Trash2 className="w-4 h-4" />
        {m.deleteInstruction}
      </Button>
      <DeleteInstructionDialog
        open={open}
        title={instructionTitle}
        onOpenChange={setOpen}
        onConfirm={() => {
          setOpen(false)
          onDelete()
        }}
      />
    </>
  )
}
